import { staffWorksAtAnyLocation } from '../../../locations/utils/locationAssignmentUtils';
import { normalizeEmployeeIds } from './serviceStaffAssignmentUtils';

export const isSelfServiceAssignmentEnabled = (companyData) =>
  companyData?.settings?.allowEmployeeSelfServiceAssignment === true;

export const getServicesAssignedToEmployee = (services = [], employeeId) => {
  const normalizedEmployeeId = String(employeeId || '').trim();
  if (!normalizedEmployeeId) return [];

  return services.filter((service) =>
    normalizeEmployeeIds(service?.employeeIds).includes(normalizedEmployeeId)
  );
};

export const getEligibleServicesForEmployee = ({
  services = [],
  employee = null,
  locations = [],
}) => {
  if (!employee) return [];

  return services.filter((service) =>
    staffWorksAtAnyLocation(employee, service?.locationIds, locations)
  );
};

export const buildNextEmployeeIdsForSelfToggle = ({
  currentEmployeeIds = [],
  employeeId,
  assigned,
}) => {
  const normalizedEmployeeId = String(employeeId || '').trim();
  const selectedIds = normalizeEmployeeIds(currentEmployeeIds);

  if (!normalizedEmployeeId) {
    return selectedIds;
  }

  if (assigned) {
    return selectedIds.includes(normalizedEmployeeId)
      ? selectedIds
      : [...selectedIds, normalizedEmployeeId];
  }

  return selectedIds.filter((id) => id !== normalizedEmployeeId);
};
